import { createFileRoute } from "@tanstack/react-router"
import { LoadingScreen } from "@/ui"

export const Route = createFileRoute("/(user)/(tenant)/briefs")({
  component: RouteComponent,
})

function RouteComponent() {
  return <LoadingScreen />
}
